export default {
  family_attribute: state => state.family_attribute,
};
